export default __webpack_public_path__ + "static/media/me.82ccfa11.png";